import type { FaireReviewEntity } from "../../entity_types/review";

// Real per-product review for Viverano Organics' "Floral Print & Lace Baby
// Girl Romper (Organic)" (p_whvbx696kg), read from GET
// /api/product-reviews/product/p_whvbx696kg — verbatim comment, real
// reviewer, real rating, real publish date.
export const review_vo4: FaireReviewEntity = {
  token: "review_vo4",
  type: "review",
  brandName: "Viverano Organics",
  brandToken: "b_7fghelgl",
  productToken: "p_whvbx696kg",
  reviewType: "product",
  reviewerName: "Abbie C.",
  reviewerLocation: "North Myrtle Beach, SC",
  stars: 5,
  reviewText: "Fast seller in the store!",
  reviewDate: "Nov 25, 2024",
  meta: {
    source: "api",
    importedAt: "2026-08-13T18:00:00.000Z",
    importedBy: "entity-db-cli",
  },
};
